import type { theme } from "@/theme/theme";
import type { colors } from "@/theme/colors";

export enum IThemeModeEnum {
  Light = "light",
  Dark = "dark",
}
export enum ISystemThemeModeEnum {
  Light = "light",
  Dark = "dark",
  System = "system",
}

export type IThemeObjectType = Record<
  IThemeModeEnum,
  Record<
    string,
    {
      colorKey: string;
      colorValue: string;
    }
  >
>;

export type IFixedColors = keyof typeof colors;
export type IThemeType = typeof theme;
export type IThemeColors = keyof IThemeType["light"];
export type IColors = IFixedColors | IThemeColors;
